import { Building, Calendar, DollarSign, Package, User } from "lucide-react";
import { FC } from "react";
import { getPriorityBadge } from "./get-priority";
import { Form } from "antd";
import { TaskFormValues } from "./type";
import { TClient, TStaff } from "~/types";
import dayjs from "dayjs";

type Props = {
  staffs?: TStaff[];
  clients?: TClient[];
};

export const TaskPreview: FC<Props> = ({ staffs, clients }) => {
  return (
    <Form.Item shouldUpdate noStyle>
      {({ getFieldValue, getFieldsValue }) => {
        const title = getFieldValue("title");
        const formData = getFieldsValue() as TaskFormValues;
        if (!title) return null;
        return (
          <div className="bg-white rounded-lg border shadow-sm mb-6">
            <div className="p-4 border-b">
              <h2 className="font-medium">Task Preview</h2>
            </div>

            <div className="p-4">
              <div className="flex justify-between items-start">
                <div className="flex-1">
                  <div className="flex items-center space-x-2 mb-2">
                    <div className="p-1 rounded bg-blue-100">
                      <Package size={16} />
                    </div>
                    <div className="font-medium">{formData?.title}</div>
                  </div>

                  <div className="text-sm text-gray-600 mb-2">
                    {formData?.description || "No description provided"}
                  </div>

                  <div className="flex items-center flex-wrap gap-2 text-sm">
                    {formData?.dueDate && (
                      <div className="flex items-center space-x-1 text-gray-500">
                        <Calendar size={14} />
                        <span>
                          {dayjs(formData?.dueDate).format("YYYY-MM-DD")}
                        </span>
                      </div>
                    )}
                    {formData?.assigneeIds &&
                      formData?.assigneeIds?.length > 0 && (
                        <div className="flex items-center space-x-1 text-gray-500">
                          <User size={14} />
                          <span>
                            {formData?.assigneeIds?.length > 2
                              ? `${
                                  staffs?.find(
                                    (s) => s.id === formData?.assigneeIds?.[0]
                                  )?.user.username
                                } +${formData?.assigneeIds?.length - 1}`
                              : formData?.assigneeIds
                                  ?.map(
                                    (id) =>
                                      staffs?.find((s) => s.id === id)?.user
                                        .username
                                  )
                                  .join(", ")}
                          </span>
                        </div>
                      )}
                    {formData?.clientId && (
                      <div className="flex items-center space-x-1 text-gray-500">
                        <Building size={14} />
                        <span>
                          {(() => {
                            const client = clients?.find(
                              (c) => c.id === formData?.clientId
                            );
                            return client?.companyName || "Unknown Client";
                          })()}
                        </span>
                      </div>
                    )}
                    {formData?.billable && (
                      <div className="flex items-center space-x-1 text-green-600">
                        <DollarSign size={14} />
                        <span>Billable</span>
                      </div>
                    )}
                  </div>
                </div>

                <div className="flex flex-col items-end space-y-2">
                  <div className="flex items-center space-x-2">
                    <span className="px-2 py-1 rounded-full text-xs bg-yellow-100 text-yellow-800">
                      Pending
                    </span>
                    {formData?.priority && getPriorityBadge(formData?.priority)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      }}
    </Form.Item>
  );
};
